//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import PageWorkOrderInfo from "../componets/page-workOrder-info";
import SelectCompanyPopup from "./select-company-popup";
import {formatDate} from "../../../../lib/date";
import {saveSplitWorkOrders} from "../../../../api/workOrder"

export default {
    name: "index",
    components: {SelectCompanyPopup, PageWorkOrderInfo},
    data() {
        return {
            show: false,
            saving: false,
            companyPopup: false,
            splitDto: {
                content: ''
            },
            list: [],
            isEdit: false
        }
    },
    computed: {
        workOrderInfo() {
            return this.$store.state.workOrder.workOrderInfo;
        }
    },
    methods: {
        getWorkOrderById() {
            this.$toast.loading({
                duration: 0,
                message: ''
            });
            this.$store.dispatch({
                type: 'workOrder/getWorkOrderById',
                id: this.id
            }).then((res) => {
                // this.workOrderInfo = this.$store.state.workOrder.workOrderInfo;
                // this.init();
            }).finally(() => {
                this.$toast.clear();
            })
        },
        onCancel() {
            this.show = false;
        },
        onSave() {
            this.list.push(this.splitDto)
            this.show = false;
        },
        onCompanySelected(data) {
            console.log(data)
            this.splitDto.positionId = data.positionId
            this.splitDto.companyId = data.companyId
            this.splitDto.fieldValue = data.fieldValue
            this.companyPopup = false;
        },

        onShow(i) {
            this.splitDto = {}
            this.splitDto = JSON.parse(JSON.stringify(this.workOrderInfo));
            this.splitDto.id = 0;
            this.isEdit = false;
            this.show = true;
        },
        onShowEdit(row) {
            this.splitDto = row;
            this.isEdit = true;
            this.show = true;
        },
        onDelDto(index) {
            // this.list.remove(i);
            this.list.splice(index, 1);
        },
        onSplitWorkOrder() {
            let page = {
                workOrderId: this.workOrderInfo.id,
                list: this.list
            }
            // console.log(page)
            this.saving = true;
            saveSplitWorkOrders(page).then(res => {
                this.$router.back();
            }).finally(() => {
                this.saving = false;
            })
        }
    },
    created() {
        this.id = parseInt(this.$route.params.id) || 0;
        if (this.id > 0) {
            this.getWorkOrderById();
            // this.getBuildingRepairer();
        }
    },
    filters: {
        formatDate(time, type) {
            var date = new Date(time);
            if (type === 1) {
                return formatDate(date, 'yyyy/MM/dd');
            }
            return formatDate(date, 'yyyy-MM-dd hh:mm');
        }
    },
}
